import { TeamInfoPayload } from 'Shared/types/TeamInfo.types';
import PiInstance from './Pi.instance';

export const getUser = ({ companyGuid, userGuid }: { companyGuid: string; userGuid: string }) =>
  PiInstance.instance.get(`/perform/api/v5/companies/${companyGuid}/person/details/${userGuid}`);

export const createBehavioralAssessment = ({ companyGuid, payload }: { companyGuid: string; payload: any }) =>
  PiInstance.instance.post(`/perform/api/v5/companies/${companyGuid}/behavioralassessment/employee`, payload);

export const getTeamInfo = (payload: TeamInfoPayload) => PiInstance.instance.post('/perform/api/v5/teamInfo', payload);
